<template>
    <div class="name-number-styling">
       

        <div class="styling-section">
            <div class="styling-section-header">
                <span class="section-label">Styling</span>
                <div class="header-right">
                    <span class="view-badge">{{ viewDisplayName }}</span>
                    <button
                        type="button"
                        class="collapse-btn"
                        @click="isCollapsed = !isCollapsed"
                        :title="isCollapsed ? 'Expand' : 'Collapse'"
                    >
                        <svg
                            v-if="isCollapsed"
                            class="collapse-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 9L12 15L18 9"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <svg
                            v-else
                            class="collapse-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 15L12 9L18 15"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            <div class="styling-section-body" v-show="!isCollapsed">
            <div class="checkbox-row">
                <div class="checkbox-item">
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            :checked="addName"
                            @change="onAddNameChange($event)"
                        />
                        <span class="checkbox-text">
                            <span class="checkbox-label-line">Add Name</span>
                            <span class="price-text"
                                >({{ formatPrice(nameFees) }} / Item)</span
                            >
                        </span>
                    </label>
                </div>
                <div class="checkbox-item">
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            :checked="addNumber"
                            @change="onAddNumberChange($event)"
                        />
                        <span class="checkbox-text">
                            <span class="checkbox-label-line">Add Number</span>
                            <span class="price-text"
                                >({{ formatPrice(numberFees) }} / Item)</span
                            >
                        </span>
                    </label>
                </div>
            </div>

            <div class="settings-row">
                <div class="settings-column" :class="{ disabled: !addName }">
                    <div class="setting-group">
                        <label class="setting-label">Font</label>
                        <select
                            class="setting-select"
                            :value="nameSettings.fontFamily"
                            @change="
                                onNameSettingChange(
                                    'fontFamily',
                                    $event.target.value
                                )
                            "
                            :disabled="!addName"
                        >
                            <option value="Verdana">Verdana</option>
                            <option value="Arial">Arial</option>
                            <option value="Georgia">Georgia</option>
                        </select>
                    </div>
                    <div class="setting-group">
                        <label class="setting-label"
                            >Font Size Height
                            <span class="unit">(Inches)</span></label
                        >
                        <select
                            class="setting-select"
                            :value="nameSettings.fontSize"
                            @change="
                                onNameSettingChange(
                                    'fontSize',
                                    $event.target.value
                                )
                            "
                            :disabled="!addName"
                        >
                            <option value="21">1.5&Prime;</option>
                            <option value="28">2&Prime;</option>
                            <option value="42">3&Prime;</option>
                        </select>
                    </div>
                    <div class="setting-group">
                        <label class="setting-label">Color</label>
                        <v-select
                            class="color-select"
                            :options="nameColorOptions"
                            :value="selectedNameColor"
                            @input="onNameColorChange"
                            :get-option-label="(option) => option.name"
                            label="name"
                            placeholder="Select color"
                            :disabled="!addName"
                        >
                            <template #option="{ hex, name, swatches }">
                                <span v-if="hex" class="color-option">
                                    <span
                                        class="color-swatch"
                                        :style="'background:' + hex"
                                    ></span>
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                                <span v-else class="color-option">
                                    <img
                                        class="color-swatch-img"
                                        :src="swatches"
                                        alt=""
                                    />
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                            </template>
                            <template
                                #selected-option="{ hex, name, swatches }"
                            >
                                <span v-if="hex" class="color-option">
                                    <span
                                        class="color-swatch"
                                        :style="'background:' + hex"
                                    ></span>
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                                <span v-else class="color-option">
                                    <img
                                        class="color-swatch-img"
                                        :src="swatches"
                                        alt=""
                                    />
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                            </template>
                        </v-select>
                    </div>
                </div>

                <div class="settings-column" :class="{ disabled: !addNumber }">
                    <div class="setting-group">
                        <label class="setting-label">Font</label>
                        <select
                            class="setting-select"
                            :value="numberSettings.fontFamily"
                            @change="
                                onNumberSettingChange(
                                    'fontFamily',
                                    $event.target.value
                                )
                            "
                            :disabled="!addNumber"
                        >
                            <option value="Verdana">Verdana</option>
                            <option value="Arial">Arial</option>
                            <option value="Georgia">Georgia</option>
                        </select>
                    </div>
                    <div class="setting-group">
                        <label class="setting-label"
                            >Number Size Height
                            <span class="unit">(Inches)</span></label
                        >
                        <select
                            class="setting-select"
                            :value="numberSettings.fontSize"
                            @change="
                                onNumberSettingChange(
                                    'fontSize',
                                    $event.target.value
                                )
                            "
                            :disabled="!addNumber"
                        >
                            <option
                                v-for="size in numberSizesList"
                                :key="size.pixel_val"
                                :value="size.pixel_val"
                            >
                                {{ size.size_number }}&Prime;
                            </option>
                        </select>
                    </div>
                    <div class="setting-group">
                        <label class="setting-label">Color</label>
                        <v-select
                            class="color-select"
                            :options="numberColorOptions"
                            :value="selectedNumberColor"
                            @input="onNumberColorChange"
                            :get-option-label="(option) => option.name"
                            label="name"
                            placeholder="Select color"
                            :disabled="!addNumber"
                        >
                            <template #option="{ hex, name, swatches }">
                                <span v-if="hex" class="color-option">
                                    <span
                                        class="color-swatch"
                                        :style="'background:' + hex"
                                    ></span>
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                                <span v-else class="color-option">
                                    <img
                                        class="color-swatch-img"
                                        :src="swatches"
                                        alt=""
                                    />
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                            </template>
                            <template
                                #selected-option="{ hex, name, swatches }"
                            >
                                <span v-if="hex" class="color-option">
                                    <span
                                        class="color-swatch"
                                        :style="'background:' + hex"
                                    ></span>
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                                <span v-else class="color-option">
                                    <img
                                        class="color-swatch-img"
                                        :src="swatches"
                                        alt=""
                                    />
                                    <span class="color-option-label">{{
                                        name
                                    }}</span>
                                </span>
                            </template>
                        </v-select>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NameNumberStyling",
    data() {
        return {
            isCollapsed: false
        };
    },
    props: {
        activeView: { type: String, default: "front" },
        addName: { type: Boolean, default: false },
        addNumber: { type: Boolean, default: false },
        nameSettings: {
            type: Object,
            default: function () {
                return {};
            }
        },
        numberSettings: {
            type: Object,
            default: function () {
                return {};
            }
        },
        vinylColorList: {
            type: Array,
            default: function () {
                return [];
            }
        },
        nameFees: { type: Number, default: 0 },
        numberFees: { type: Number, default: 0 },
        numberSizesList: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    computed: {
        viewDisplayName() {
            var v = this.activeView;
            if (v === "front") return "Front";
            if (v === "back") return "Back";
            if (v === "left") return "Left Sleeve";
            if (v === "right") return "Right Sleeve";
            return v;
        },
        // Options for dropdown: vinyl list + current selection if not in list (so selected color always shows)
        nameColorOptions() {
            var list = this.vinylColorList || [];
            var s = this.nameSettings || {};
            if (s.colorId != null && s.fontColor) {
                var inList = list.some(function (c) {
                    return c.id == s.colorId;
                });
                if (!inList) {
                    return [
                        {
                            id: s.colorId,
                            hex: s.fontColor,
                            name: s.colorName || "Selected"
                        }
                    ].concat(list);
                }
            }
            return list;
        },
        numberColorOptions() {
            var list = this.vinylColorList || [];
            var s = this.numberSettings || {};
            if (s.colorId != null && s.fontColor) {
                var inList = list.some(function (c) {
                    return c.id == s.colorId;
                });
                if (!inList) {
                    return [
                        {
                            id: s.colorId,
                            hex: s.fontColor,
                            name: s.colorName || "Selected"
                        }
                    ].concat(list);
                }
            }
            return list;
        },
        selectedNameColor() {
            if (!this.addName) return null;
            var list = this.nameColorOptions;
            var id = this.nameSettings && this.nameSettings.colorId;
            if (id == null) return list[0] || null;
            return (
                list.find(function (c) {
                    return c.id == id;
                }) ||
                list[0] ||
                null
            );
        },
        selectedNumberColor() {
            if (!this.addNumber) return null;
            var list = this.numberColorOptions;
            var id = this.numberSettings && this.numberSettings.colorId;
            if (id == null) return list[0] || null;
            return (
                list.find(function (c) {
                    return c.id == id;
                }) ||
                list[0] ||
                null
            );
        }
    },
    methods: {
        formatPrice(val) {
            if (val == null || isNaN(val)) return "$0.00";
            return "$" + parseFloat(val).toFixed(2);
        },
        onAddNameChange(e) {
            this.$emit("update:addName", e.target.checked);
        },
        onAddNumberChange(e) {
            this.$emit("update:addNumber", e.target.checked);
        },
        onNameSettingChange(key, value) {
            var s = Object.assign({}, this.nameSettings);
            s[key] = value;
            this.$emit("update:nameSettings", s);
        },
        onNumberSettingChange(key, value) {
            var s = Object.assign({}, this.numberSettings);
            s[key] = value;
            this.$emit("update:numberSettings", s);
        },
        onNameColorChange(option) {
            if (!option) return;
            var s = Object.assign({}, this.nameSettings);
            s.fontColor = option.hex;
            s.colorId = option.id;
            s.colorName = option.name;
            this.$emit("update:nameSettings", s);
        },
        onNumberColorChange(option) {
            if (!option) return;
            var s = Object.assign({}, this.numberSettings);
            s.fontColor = option.hex;
            s.colorId = option.id;
            s.colorName = option.name;
            this.$emit("update:numberSettings", s);
        }
    }
};
</script>

<style scoped>
    
.name-number-styling {
    background: #fff;
    padding: 12px;
    box-shadow: 0px 2px 8px 0px #00000014;
}
.styling-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eee;
}
.section-label {
    font-weight: 600;
}
.header-right {
    display: flex;
    align-items: center;
    gap: 6px;
}
.view-badge {
    background: #B6B6B666;
    color: black;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.85rem;
}
.collapse-btn {
    background: none;
    border: none !important;
    padding: 4px;
    cursor: pointer;
    color: #333;
}
.collapse-icon {
    width: 20px;
    height: 20px;
}
.styling-section-body {
    padding-top: 4px;
}
.checkbox-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 16px;
}
.checkbox-item {
    display: flex;
    align-items: center;
}
.checkbox-label {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    cursor: pointer;
}

/* Custom checkbox to match design */
.checkbox-label input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 2px solid #c4c4c4;
    background-color: #ffffff;
    margin-top: 2px;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
}

.checkbox-label input[type="checkbox"]:hover {
    border-color: #0079c1;
}

.checkbox-label input[type="checkbox"]::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 6px;
    height: 10px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    transform: rotate(45deg);
    opacity: 0;
}

.checkbox-label input[type="checkbox"]:checked {
    background-color: #0079c1;
    border-color: #0079c1;
}

.checkbox-label input[type="checkbox"]:checked::after {
    opacity: 1;
}
.checkbox-text {
    font-size: 0.9rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.checkbox-label-line {
    display: block;
    font-weight: 400;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
}
.price-text {
    color: #666;
    font-size: 0.85rem;
    display: block;
}
.settings-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}
.settings-column.disabled {
    opacity: 0.6;
    pointer-events: none;
}
.setting-group {
    margin-bottom: 12px;
}

.setting-label span{
    color: #929292;
}
.setting-select,
.color-select {
    width: 100%;
    padding: 6px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}
.setting-select {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.color-select ::v-deep .vs__search {
    font-size: 14px !important;
    padding-left: 2px !important;
}

/* Color v-select: single line + ellipsis for long names (name + number columns) */
.color-option {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    text-align: left;
}

.color-option-label {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.color-swatch,
.color-swatch-img {
    flex-shrink: 0;
}

.color-swatch {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    display: inline-block;
}

.color-swatch-img {
    width: 16px;
    height: 16px;
    object-fit: contain;
}

/* vue-select: selected row must shrink so label ellipsis never covers the caret */
.color-select ::v-deep .vs__dropdown-toggle {
    display: flex !important;
    align-items: center;
    min-height: 38px;
    width: 100%;
    min-width: 0;
    overflow: hidden;
}

/* Keep clear space for the dropdown arrow */
.color-select ::v-deep .vs__actions {
    flex-shrink: 0;
    align-self: center;
    margin-left: 4px;
}

.color-select ::v-deep .vs__selected-options {
    display: flex;
    flex: 1 1 0%;
    flex-wrap: nowrap;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

.color-select ::v-deep .vs__selected {
    display: flex !important;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
}

/* Selected value: don’t use width:100% — it prevents flex from constraining text */
.color-select ::v-deep .vs__selected .color-option {
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    max-width: 100%;
}

.color-select ::v-deep .vs__dropdown-option {
    overflow: hidden;
}

.color-select ::v-deep .vs__dropdown-option .color-option {
    min-width: 0;
}

</style>
